import { render } from "./CoinInput.vue?vue&type=template&id=77cdcfdf"
import script from "./CoinInput.vue?vue&type=script&lang=js"
export * from "./CoinInput.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__